<template lang="pug">
    .cell-content-wrapper.l-flex-row.l-align-center(v-if="hasChildren" @click.stop="handleClick")
        svg-icon(v-if="expandedRows.includes(fullData.id)" name='arrow_thin_bottom' size="small")
        svg-icon(v-else name='arrow_thin_right' size="small")
</template>

<script>
import { mapState } from 'vuex'
import { get, isEmpty } from 'lodash'

export default {
    props: {
        clickOnCell: {
            type: Function,
            default: () => {}
        },
        data: {
            type: [Function, Array, String, Number],
            default: null
        },
        type: {
            type: String,
            default: ''
        },
        fullData: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        ...mapState('ui/monitoring', {
            expandedRows: state => state.expandedRows
        }),
        ...mapState('data/transfer', {
            transfers: state => state.list
        }),
        hasChildren() {
            return !isEmpty(get(this.transfers, `${this.fullData.id}`, []))
        }
    },
    methods: {
        handleClick() {
            this.$emit('clickOnCell', this.fullData.id)
        }
    }
}
</script>
